module.exports = __webpack_public_path__ + "static/Zasób 11@2x-ed521a8768d552fb0a43eef7eaa6dd8d.png";